import AccountNotFound from './AccountNotFound';

export default AccountNotFound;
